import React, { useMemo, useState } from "react";
import { Container, Row, Col, Card, Badge, Form, Button } from "react-bootstrap";

const JobOpening = () => {
  const [query, setQuery] = useState("");
  const [dept, setDept] = useState("All");

  const jobs = useMemo(
    () => [
      {
        id: 1,
        title: "Software Developer",
        dept: "Development",
        type: "Full-time",
        experience: "0–3 Years",
        location: "On-site / Hybrid",
        description:
          "Work on web applications, build modules, and maintain existing systems. Collaborate with QA and project teams to deliver reliable features.",
        mustHave: [
          "Dot Net (Code-behind) + C#",
          "PHP",
          "MySQL",
          "CodeIgniter",
        ],
        responsibilities: [
          "Develop and maintain web applications",
          "Write clean, maintainable code",
          "Fix bugs and improve performance",
          "Coordinate with team for timelines and delivery",
        ],
      },
      {
        id: 2,
        title: "Digital Marketing",
        dept: "Marketing",
        type: "Full-time",
        experience: "0–3 Years",
        location: "On-site",
        description:
          "Plan and execute digital campaigns to improve brand visibility and generate leads. Track performance and optimize continuously.",
        mustHave: [
          "SEO basics (On-page/Off-page)",
          "Social media marketing",
          "Content planning",
          "Google tools (Analytics / Search Console) - preferred",
        ],
        responsibilities: [
          "Manage social media pages and campaigns",
          "Assist with SEO and content strategy",
          "Create and schedule posts",
          "Monitor analytics and report results",
        ],
      },
      {
        id: 3,
        title: "Software Support Executive",
        dept: "Support",
        type: "Full-time",
        experience: "0–3 Years",
        location: "On-site",
        description:
          "Provide customer support for software products, handle tickets, and assist users with troubleshooting and basic training.",
        mustHave: [
          "Good communication skills",
          "Basic software troubleshooting",
          "Ticket handling / customer support mindset",
          "Willingness to learn product workflows",
        ],
        responsibilities: [
          "Handle customer issues via phone/email",
          "Track issues and escalate when needed",
          "Assist in demos/training as required",
          "Maintain support documentation",
        ],
      },
    ],
    []
  );

  const departments = useMemo(
    () => ["All", "Development", "Marketing", "Support"],
    []
  );

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return jobs.filter((job) => {
      const matchDept = dept === "All" ? true : job.dept === dept;
      const matchQuery =
        !q ||
        job.title.toLowerCase().includes(q) ||
        job.dept.toLowerCase().includes(q) ||
        job.mustHave.join(" ").toLowerCase().includes(q);
      return matchDept && matchQuery;
    });
  }, [jobs, query, dept]);

  // ✅ ONLY EMAIL UPDATED (NO CC, BOTH EMAILS)
  const handleApply = (jobTitle) => {
    const emails = "ebs.slg@gmail.com,jobs@ebssoftware.co.in";

    const subject = encodeURIComponent(`Job Application - ${jobTitle}`);
    const body = encodeURIComponent(
      `Hello Team,\n\nI would like to apply for the position: ${jobTitle}.\n\nName:\nPhone:\nExperience:\nCurrent Location:\nNotice Period:\nResume Attached:\n\nThanks,\n`
    );

    window.location.href = `mailto:${emails}?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <Container className="py-4">
        <Row className="mb-3">
          <Col lg={12}>
            <h2 style={{ fontWeight: "bold", textAlign: "center" }}>
              Job Openings
            </h2>
            <p style={{ textAlign: "center", marginTop: 10, opacity: 0.9 }}>
              Explore current openings and apply to join our team.
            </p>
          </Col>
        </Row>

        {/* Filters */}
        <Row className="align-items-end g-3 mb-4">
          <Col lg={6}>
            <Form.Label style={{ fontWeight: 600 }}>Search</Form.Label>
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search by title, department, skills..."
            />
          </Col>

          <Col lg={4}>
            <Form.Label style={{ fontWeight: 600 }}>Department</Form.Label>
            <Form.Select value={dept} onChange={(e) => setDept(e.target.value)}>
              {departments.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col lg={2} className="d-grid">
            <Button
              variant="dark"
              onClick={() => {
                setQuery("");
                setDept("All");
              }}
            >
              Reset
            </Button>
          </Col>
        </Row>

        {/* Jobs */}
        <Row className="g-4">
          {filtered.length === 0 ? (
            <Col lg={12}>
              <div
                style={{
                  border: "1px dashed #ccc",
                  borderRadius: 12,
                  padding: 24,
                  textAlign: "center",
                }}
              >
                No jobs found. Try a different search.
              </div>
            </Col>
          ) : (
            filtered.map((job) => (
              <Col lg={12} key={job.id}>
                <Card style={{ borderRadius: 14 }}>
                  <Card.Body>
                    <Row className="align-items-start">
                      <Col lg={9}>
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                            flexWrap: "wrap",
                          }}
                        >
                          <h4 style={{ marginBottom: 0, fontWeight: 800 }}>
                            {job.title}
                          </h4>
                          <Badge bg="secondary" style={{ height: "fit-content" }}>
                            {job.dept}
                          </Badge>
                          <Badge bg="info" style={{ height: "fit-content" }}>
                            {job.type}
                          </Badge>
                        </div>

                        <div style={{ marginTop: 8, opacity: 0.85 }}>
                          <span style={{ marginRight: 16 }}>
                            <strong>Experience:</strong> {job.experience}
                          </span>
                          <span>
                            <strong>Location:</strong> {job.location}
                          </span>
                        </div>

                        <p style={{ marginTop: 12, textAlign: "justify" }}>
                          {job.description}
                        </p>

                        <Row className="mt-3">
                          <Col lg={6} className="mb-3 mb-lg-0">
                            <h6 style={{ fontWeight: 800 }}>Must have skills</h6>
                            <ul style={{ marginBottom: 0 }}>
                              {job.mustHave.map((s, idx) => (
                                <li key={idx}>{s}</li>
                              ))}
                            </ul>
                          </Col>

                          <Col lg={6}>
                            <h6 style={{ fontWeight: 800 }}>
                              Responsibilities
                            </h6>
                            <ul style={{ marginBottom: 0 }}>
                              {job.responsibilities.map((r, idx) => (
                                <li key={idx}>{r}</li>
                              ))}
                            </ul>
                          </Col>
                        </Row>
                      </Col>

                      <Col lg={3} className="mt-3 mt-lg-0">
                        <div
                          style={{
                            border: "1px solid #eee",
                            borderRadius: 12,
                            padding: 16,
                            background: "#fafafa",
                          }}
                        >
                          <h6 style={{ fontWeight: 800, marginBottom: 10 }}>
                            Apply Now
                          </h6>

                          {/* ✅ TEXT UPDATED AS YOU ASKED */}
                          <p
                            style={{
                              fontSize: 14,
                              marginBottom: 12,
                              opacity: 0.85,
                            }}
                          >
                            Click below to email your resume to:
                            <br />
                            <strong>
                              ebs.slg@gmail.com / jobs@ebssoftware.co.in
                            </strong>
                          </p>

                          <div className="d-grid gap-2">
                            <Button
                              variant="primary"
                              onClick={() => handleApply(job.title)}
                            >
                              Apply for {job.title}
                            </Button>
                            <Button
                              variant="outline-dark"
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "smooth" })
                              }
                            >
                              Back to Top
                            </Button>
                          </div>

                          <hr />
                          <p
                            style={{
                              fontSize: 13,
                              marginBottom: 0,
                              opacity: 0.75,
                            }}
                          >
                            Tip: Attach your updated CV and mention your notice
                            period.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))
          )}
        </Row>
      </Container>
    </>
  );
};

export default JobOpening;
